import { rem } from 'polished'

import { css, styled } from '../theme'
import { colors } from '../theme/colors'
import { media } from '../theme/media'

export interface Props {
  primary?: boolean
  secondary?: boolean
  tertiary?: boolean
  grey?: boolean
  whitePrimary?: boolean
  whiteSecondary?: boolean
  disabled?: boolean
  type?: string
  compact?: boolean
}

export const Button = styled.button.attrs(p => ({
  type: p.type ? p.type : 'button',
}))<Props>`
  position: relative;
  display: inline-flex;
  justify-content: center;
  width: ${p => !p.compact && '100%'};
  height: ${p => rem(p.theme.controls.height)};
  padding: 20px;

  ${media.tablet`    
    &:not(:last-child) {
      margin-right: ${rem(5)};
    }
  `}

  color: ${colors.white};
  text-decoration: none;
  border-width:0;

  cursor: ${p => (p.disabled ? 'default' : 'pointer')};
  opacity: ${p => p.disabled && 0.4};

  &::after {
    content:"";
    position: absolute;
    height: 5px;
    left: 0;
    bottom:0;
    right:0;
  }

  /* ${p => p.theme.font.m()} */
  ${p => (p.compact ? p.theme.font.s() : p.theme.font.m())}
  line-height: 1; /* sobreescribimos el line-height para centrar el texto */
  will-change: opacity;
  transition-delay: 0.05s;

  ${p =>
    ((!p.primary &&
      !p.secondary &&
      !p.tertiary &&
      !p.grey &&
      !p.whitePrimary &&
      !p.whiteSecondary) ||
      p.primary) &&
    css`
      background-color: ${colors.primary};
      transition: background-color 0.3s, color 0.3s;
      &::after {
        background-color: ${colors.primaryDark};
      }

      &:hover:not([disabled]) {
        background-color: ${colors.primaryDark};
      }
    `}

  ${p =>
    p.secondary &&
    css`
      background-color: ${colors.secondary};
      transition: background-color 0.3s, color 0.3s;
      &::after {
        background-color: ${colors.secondaryDark};
      }

      &:hover:not([disabled]) {
        background-color: ${colors.secondaryDark};
      }
    `}

  ${p =>
    p.tertiary &&
    css`
      background-color: ${colors.ternary};
      transition: background-color 0.3s, color 0.3s;
      &::after {
        background-color: ${colors.ternaryDark};
      }

      &:hover:not([disabled]) {
        background-color: ${colors.ternaryDark};
      }
    `}

  ${p =>
    p.grey &&
    css`
      background-color: ${colors.gray};
      transition: background-color 0.3s, color 0.3s;
      &::after {
        background-color: ${colors.grayDark};
      }
      &:hover:not([disabled]) {
        background-color: ${colors.grayDark};
      }
    `}

  ${p =>
    p.whitePrimary &&
    css`
      background-color: ${colors.white};
      color: ${colors.primary};
      transition: background-color 0.3s, color, 0.3s;
      &::after {
        background-color: ${colors.primaryDark};
        color: ${colors.white};
      }
      &:hover:not([disabled]) {
        background-color: ${colors.primaryDark};
        color: ${colors.white};
      }
    `}

  ${p =>
    p.whiteSecondary &&
    css`
      background-color: ${colors.white};
      color: ${colors.secondary};
      transition: background-color 0.3s, color 0.3s;
      &::after {
        background-color: ${colors.secondaryDark};
        color: ${colors.white};
      }
      &:hover:not([disabled]) {
        background-color: ${colors.secondaryDark};
        color: ${colors.white};
      }
    `}
`
